/* Spanish catalog mirroring locale-invoice-live-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'actionApproval.approve': 'Aprobar',
  'actionApproval.approveAction': 'Aprobar: {action}',
  'live.reviewTitle': 'Revisar la factura',
  'live.reviewInvoice': 'Revisa la factura de abajo antes de aprobarla.',
  'live.deliveryLabel': 'Enviar como',
  'live.approveSend': 'Aprobar y enviar',
  'live.approveIssue': 'Aprobar y crear',
  'actionApproval.label.send_offer': 'Enviar presupuesto',
  'actionApproval.label.send_credit_note': 'Enviar nota de crédito',
  'actionApproval.label.send_reminder': 'Enviar recordatorio de pago sin recargo',
  'actionApproval.label.post_purchase': 'Registrar y contabilizar compra',
  'actionApproval.label.reverse_purchase': 'Revertir compra',
  'actionApproval.label.post_manual_voucher': 'Contabilizar justificante',
  'actionApproval.label.reverse_voucher': 'Revertir justificante',
  'actionApproval.label.approve_payroll_run': 'Aprobar y contabilizar la nómina',
  'actionApproval.label.reverse_payroll_run': 'Revertir la nómina',
  'actionApproval.label.record_payroll_submission': 'Confirmar que la a-melding se presentó fuera de Plumme',
  'actionApproval.label.close_accounting_year': 'Aprobar y cerrar el ejercicio contable',
  'actionApproval.label.reopen_accounting_year': 'Reabrir el ejercicio contable',
  'actionApproval.label.delete_invoice_drafts': 'Eliminar borradores de factura',
  'actionApproval.label.delete_purchase_draft': 'Eliminar borrador de compra',
  'actionApproval.label.delete_payroll_draft': 'Eliminar borrador de nómina',
  'actionApproval.label.delete_project': 'Eliminar proyecto',
  'actionApproval.label.invite_business_member': 'Invitar a un miembro de la empresa',
  'actionApproval.label.remove_business_member': 'Quitar el acceso de un miembro de la empresa',
  'actionApproval.label.cancel_business_invite': 'Cancelar invitación a la empresa',
  'live.reading': 'Leyendo el formulario y eligiendo el siguiente paso …',
  'live.open_editor': 'Abriendo el editor de facturas …',
  'live.set_layout': 'Cambiando la vista …',
  'live.set_customer': 'Seleccionando el cliente …',
  'live.set_field': 'Rellenando un campo …',
  'live.set_line': 'Rellenando una línea de factura …',
  'live.remove_line': 'Eliminando una línea de factura …',
  'live.open_customer_form': 'Preparando un cliente nuevo …',
  'live.open_product_form': 'Preparando un producto nuevo …',
  'live.review': 'Abriendo la vista previa …',
  'live.request_save': 'Preparando para tu aprobación …',
  'live.finish': 'Comprobando el resultado …',
  'live.ask_user': 'Se necesita una aclaración …',
  'live.approval': 'Esperando tu revisión y que guardes el formulario.',
  'live.customerApproval': 'Revisa el cliente nuevo en el formulario. En cuanto lo guardes, continúo con la factura.',
  'live.productApproval': 'Revisa el producto nuevo, el precio y el IVA en el formulario. En cuanto lo guardes, continúo con la factura.',
  'live.customerSaved': 'El cliente está guardado. Continuando con la factura.',
  'live.productSaved': 'El producto está guardado. Continuando con la factura.',
  'live.cancelled': 'Se canceló la creación. El trabajo en la factura está en pausa.',
  'live.notApplied': 'El campo no se actualizó como se esperaba. Me detuve para que puedas revisar el formulario.',
  'live.limit': 'Llegué al límite de pasos. Revisa el formulario y describe lo que falta por hacer.',
  'live.done.open_editor': 'El editor de facturas está abierto.',
  'live.done.set_layout': 'La vista se ha modificado.',
  'live.done.set_customer': 'El cliente está seleccionado.',
  'live.done.set_field': 'El campo está rellenado y comprobado.',
  'live.done.set_line': 'La línea de factura está rellenada y comprobada.',
  'live.done.remove_line': 'La línea de factura se ha eliminado.',
  'control.productRequired': 'El producto no figura en el catálogo de productos activo.',
  'control.intro': 'Describe la factura que quieres crear. Relleno el formulario y puedo crear los clientes y productos necesarios. Pídeme explícitamente que emita y envíe la factura cuando quieras que la finalice.',
  'live.create_customer': 'Guardando el cliente …',
  'live.create_product': 'Guardando el producto …',
  'live.issue_invoice': 'Emitiendo la factura …',
  'live.send_invoice': 'Emitiendo y enviando la factura …',
  'live.finished': 'He terminado de rellenar los campos. Los cambios se comprobaron en el formulario de factura.',
  'live.clarification': 'Describe qué quieres hacer a continuación con la factura.',
  'live.invoiceIssued': 'La factura está emitida. No se ha enviado.',
  'live.invoiceSent': 'La factura se envió por correo electrónico.',
  'live.emailRequired': 'Para enviar necesito el correo electrónico del cliente y el correo del remitente en los ajustes de la empresa. Indica la dirección del destinatario con una nueva solicitud de envío.',
  'live.authorizationRequired': 'Indica explícitamente qué quieres crear o enviar.',
  'live.deliveryUncertain': 'El envío ya se intentó. Comprueba el estado del envío en la lista de facturas antes de reintentarlo, para que el cliente no reciba la factura por duplicado.',
  'live.deliveryNotSent': 'La factura está emitida, pero no se confirmó el envío. Comprueba el estado del envío en la lista de facturas.',
  'live.ambiguousRecord': 'Varios clientes o productos tienen el mismo nombre. Selecciona primero el registro correcto.',
  'live.actionBusy': 'Ya hay un guardado o un envío en curso.',
  'appControl.changed': 'La página o la empresa cambió. Revisa la página y pídeme que continúe.',
  'appControl.unsupported': 'Este control debe usarse directamente en la página.',
  'appControl.authorization': 'Indícame la acción que quieres que realice.',
  'appControl.manual': 'Termina este paso directamente en la página y después podré continuar.',
  'appControl.option': 'Esta opción no está disponible en este campo.',
  'appControl.repeated': 'La acción ya se intentó. Comprueba el resultado en la página antes de continuar.',
  'actionApproval.title': 'Aprobar la acción',
  'actionApproval.body': 'Revisa la acción y la información de abajo. La aprobación solo es válida para este paso.',
  'actionApproval.confirm': 'Aprobar y ejecutar',
  'actionApproval.proposal': 'Acción propuesta',
  'actionApproval.context': 'Información afectada por la acción',
  'actionApproval.cancel': 'Cancelar',
  'actionApproval.mcp': 'Acción de una IA conectada',
  'actionApproval.failed': 'No se pudo ejecutar la acción. Pide una nueva propuesta e inténtalo de nuevo.',
  'actionApproval.loading': 'Cargando la acción ...',
  'actionApproval.done': 'La acción se ejecutó.',
  'actionApproval.business': 'Empresa',
  'actionApproval.writeScope': 'La IA puede proponer acciones de escritura. Debes aprobar cada acción en Plumme antes de que se ejecute.',
  'actionApproval.label.create_invoice_draft': 'Crear borrador de factura',
  'actionApproval.label.register_invoice_payment': 'Registrar pago de factura',
  'actionApproval.label.save_draft': 'Guardar borrador',
  'actionApproval.label.send_invoice': 'Enviar factura',
  'actionApproval.label.issue_invoice': 'Emitir factura',
  'actionApproval.label.create_customer': 'Crear cliente',
  'actionApproval.label.create_product': 'Crear producto',
  'actionApproval.label.invoice': 'Factura',
  'actionApproval.label.invoiceId': 'ID de factura',
  'actionApproval.label.customer': 'Cliente',
  'actionApproval.label.customerName': 'Nombre del cliente',
  'actionApproval.label.currency': 'Moneda',
  'actionApproval.label.amount': 'Importe',
  'actionApproval.label.date': 'Fecha',
  'actionApproval.label.dueDate': 'Fecha de vencimiento',
  'actionApproval.label.lines': 'Líneas',
  'actionApproval.label.quantity': 'Cantidad',
  'actionApproval.label.unitPrice': 'Precio unitario',
  'actionApproval.label.vatRate': 'Tipo de IVA',
  'actionApproval.label.description': 'Descripción',
  'actionApproval.label.business': 'Empresa',
  'actionApproval.label.expires': 'Caduca',
  'actionApproval.label.recipientEmail': 'Destinatario',
  'actionApproval.label.fields': 'Campos',
  'actionApproval.label.label': 'Nombre',
  'actionApproval.label.value': 'Valor',
  'actionApproval.label.text': 'Detalles de la página',
  'actionApproval.label.action': 'Acción',
  'actionApproval.label.click': 'Hacer clic',
  'actionApproval.label.fill': 'Rellenar',
  'actionApproval.label.select': 'Seleccionar',
  'actionApproval.label.check': 'Cambiar selección',
  'actionApproval.label.checked': 'Seleccionado',
  'actionApproval.label.post': 'Contabilizar',
  'actionApproval.label.approve': 'Aprobar la nómina',
  'actionApproval.label.close_year': 'Aprobar y cerrar el ejercicio contable',
  'actionApproval.label.reopen_year': 'Reabrir el ejercicio contable',
  'actionApproval.label.manage_members': 'Cambiar el acceso',
  'actionApproval.label.delete': 'Eliminar o revertir',
  'actionApproval.label.submit': 'Enviar',
  'actionApproval.label.expense': 'Compra',
  'actionApproval.label.supplier': 'Proveedor',
  'actionApproval.label.year': 'Año',
  'actionApproval.label.records': 'Registros',
});
